












import { PaginationPageProps } from '@/models/pagination-page-props';
import { Component, InjectReactive, Vue } from 'vue-property-decorator';

import { FeedProduct } from '../../../models';
import EntityPaginationRouter from '@/components/EntityPaginationRouter.vue';
import { sortEntitiesByStatus } from '@/common/FormattingUtils';

@Component({
	components: {
		EntityPaginationRouter,
	},
})
export default class FeedTanksTab extends Vue {
	@InjectReactive('feedProduct')
	public feedProduct!: FeedProduct | null;

	public get feedTanks() {
		return sortEntitiesByStatus(this.feedProduct?.feedtanks ?? []);
	}

	public generateUrl(pageNumber: number): { name: string; params?: { feedTankId: string } } {
		if (pageNumber === 1) {
			return { name: 'products.feed.feedtanks.overview' };
		}
		return {
			name: 'products.feed.feedtanks.tankdetail',
			params: {
				feedTankId: (this.feedTanks[pageNumber - 2]?.id ?? 0).toString(),
			},
		};
	}

	public paginationText(props: PaginationPageProps): string {
		if (props.page === 1) {
			return 'Overview';
		}
		return this.feedTanks[props.page - 2]?.name ?? '';
	}

	public badgeText(props: PaginationPageProps): string {
		const feedTank = this.feedTanks[props.page - 2];
		return Vue.filter('titleCase')(feedTank.status ?? 'No status');
	}
}
